import React from 'react'
import Reflux from 'reflux'
import {
	ButtonGroup,
	Button
} from 'reactstrap'
import _ from 'lodash'

import IngredientsStore from '~/stores/ingredients.js'
import IngredientsActions from '~/actions/ingredients.js'


export default class RecipeIngredientsModalList extends Reflux.Component {
	constructor(props) {
		super(props)

		this.store = IngredientsStore
	}

	render() {
		const letterButtons = (
			_.has(this.state, 'ingredients')
			&& _.size(this.state.ingredients) > 0
		)
			? _.uniq(_.map(this.state.ingredients, 'firstLetter')).map(
				theLetter =>
					<Button
						key={theLetter}
						color="info"
						active={this.state.ingredientFilterLetter === theLetter}
						onClick={() => IngredientsActions.setFilterLetter(theLetter)}
					>
						{theLetter}
					</Button>
				)
			: null

		return (
			<ButtonGroup>
				<Button
					color="info"
					active={this.state.ingredientFilterLetter === ''}
					onClick={() => IngredientsActions.setFilterLetter('')}
				>
					ALL INGREDIENTS
				</Button>
				{letterButtons}
			</ButtonGroup>
		)
	}
}



// WEBPACK FOOTER //
// ./src/modules/modals/ingredients/listFilterBar.jsx